<template lang="html">
	<div class="seven">
		<div class="mainbox">
			<!--顶部大图-->
			<div class="topbg">
				<img src="../../assets/image/seven/topbg.png" alt="">
			</div>
			<!--主体内容-->
			<div class="content">
				<!--part01-->
				<div class="partone">
					<div class="part_tit">
						<img src="../../assets/image/seven/icon_01.png" alt="">
					</div>
					<div class="partoneinfos partbox">
						<ul>
							<li>
								<div class="tit_img"><img src="../../assets/image/seven/onetit.png" alt=""></div>
								<div class="tit_words"><img src="../../assets/image/seven/partone_pic1.png" alt=""><span>布线靠灵感，测试靠运气，想要掌握核心研发技能，实现月月高薪，我该怎么办？</span></div>
							</li>
							<li>
								<div class="tit_img"><img src="../../assets/image/seven/twotit.png" alt=""></div>
								<div class="tit_words"><span>面试频频碰壁，想要提高面试通过率和职场竞争力，我该怎么办？</span><img src="../../assets/image/seven/partone_pic2.png" alt=""></div>
							</li>
							<li>
								<div class="tit_img"><img src="../../assets/image/seven/threetit.png" alt=""></div>
								<div class="tit_words"><img src="../../assets/image/seven/partone_pic3.png" alt=""><span>拿着流水线的工资，操着CTO的心，工作内容抓不到重点，我该怎么办？</span></div>
							</li>
							<div style="clear: both"></div>
						</ul>
					</div>
				</div>
				<!--part02-->
				<div class="parttwo">
					<div class="part_tit">
						<img src="../../assets/image/seven/icon_02.png" alt="">
					</div>
					<div class="parttwoinfos partbox">
						<ul>
							<li>
								<div class="parttwo_icon"><img src="../../assets/image/seven/parttwo_pic1.png" alt=""></div>
								<div class="parttwo_desc">
									<div><em>1</em><span>个实际硬件产品案例,即学即用</span></div>
								</div>
							</li>
							<li>
								<div class="parttwo_icon"><img src="../../assets/image/seven/parttwo_pic2.png" alt=""></div>
								<div class="parttwo_desc">
									<div><em>3</em><span>大优质平台,共享行业资源池</span></div>
								</div>
							</li>
							<li>
								<div class="parttwo_icon"><img src="../../assets/image/seven/parttwo_pic3.png" alt=""></div>
								<div class="parttwo_desc">
									<div><em>4</em><span>大硬件设计流程,零经验快速入门</span></div>
								</div>
							</li>
							<li>
								<div class="parttwo_icon"><img src="../../assets/image/seven/parttwo_pic4.png" alt=""></div>
								<div class="parttwo_desc">
									<div><em>7</em><span>天特训,行业专家助力加速成长</span></div>
								</div>
							</li>
							<li>
								<div class="parttwo_icon"><img src="../../assets/image/seven/parttwo_pic5.png" alt=""></div>
								<div class="parttwo_desc">
									<div><em>15</em><span>个体系化特训环节,领略集成产品开发精髓</span></div>
								</div>
							</li>
							<li>
								<div class="parttwo_icon"><img src="../../assets/image/seven/parttwo_pic6.png" alt=""></div>
								<div class="parttwo_desc">
									<div><em>18</em><span>套硬件设计必备资料,助力能力提升</span></div>
								</div>
							</li>
							<div style="clear: both"></div>
						</ul>
					</div>
				</div>
				<!--part03-->
				<div class="partthree">
					<div class="part_tit">
						<img src="../../assets/image/seven/icon_03.png" alt="">
					</div>
					<div class="partthreeinfos partbox">
						<div class="partthree_box">
							<div><img src="../../assets/image/seven/partthree_pic1.png" alt=""></div>
							<div>
								<span>DAY：1</span>
								<p>实战项目概述和研发环境搭建 </p>
								<ul>
									<li><i></i>NB-loT物联网项目实训课</li>
									<li><i></i>NB-OIT物联网终端单板硬件开发</li>
									<li><i></i>硬件设计环境搭建及系统设置</li>
								</ul>
							</div>
						</div>
						<div class="partthree_box">
							<div><img src="../../assets/image/seven/partthree_pic1.png" alt=""></div>
							<div>
								<span>DAY：2</span>
								<p>项目开发需求分析 </p>
								<ul>
									<li><i></i>需求分析阶段主要活动</li>
									<li><i></i>概要设计阶段主要活动</li>
								</ul>
								<h4>附赠资料：项目工作任务书、项目需求规格书</h4>
							</div>
						</div>
						<div class="partthree_box">
							<div><img src="../../assets/image/seven/partthree_pic1.png" alt=""></div>
							<div>
								<span>DAY：3</span>
								<p>实战项目原理图设计准备 </p>
								<ul>
									<li><i></i>元器件认知及设计库关系</li>
									<li><i></i>创建原理图符号</li>
									<li><i></i> 光传感器扣板原理图绘制概述</li>
								</ul>
							</div>
						</div>
						<div class="partthree_box">
							<div><img src="../../assets/image/seven/partthree_pic1.png" alt=""></div>
							<div>
								<span>DAY：4</span>
								<p>实战项目原理图绘制及文件交付 </p>
								<ul>
									<li><i></i>添加原理图符号库&调用原理图符号</li>
									<li><i></i>编排位号&规则检查&BOM表导出</li>
								</ul>
								<h4>附赠资料：板级硬件设计方案文档</h4>
							</div>
						</div>
						<div class="partthree_box">
							<div><img src="../../assets/image/seven/partthree_pic1.png" alt=""></div>
							<div>
								<span>DAY：5</span>
								<p>实战项目pcb设计文件交付</p>
								<ul>
									<li><i></i>PCB设计基础</li>
									<li><i></i>光传感器扣板PCB设计实践操作指导</li>
								</ul>
								<h4>附赠资料1：PCB设计快速入门文档 <br>
									附赠资料2：SCH设计快速入门文档 <br>
									附赠资料3：allegro 3D模型资料</h4>
							</div>
						</div>
						<div class="partthree_box">
							<div><img src="../../assets/image/seven/partthree_pic1.png" alt=""></div>
							<div>
								<span>DAY：6</span>
								<p>单板调测</p>
								<ul>
									<li><i></i>单板调试与单元测试方案</li>
									<li><i></i>可编程直流电源</li>
									<li><i></i>示波器</li>
								</ul>
								<h4>附赠资料1：单板硬件调试和单元测试方案与报告 <br>
									附赠资料2：项目总结报告
								</h4>
							</div>
						</div>
						<div class="partthree_box">
							<div><img src="../../assets/image/seven/partthree_pic1.png" alt=""></div>
							<div>
								<span>DAY：7</span>
								<p>检验学习成果</p>
								<ul>
									<li><i></i>华为、中兴等大厂，硬件工程师面试测验</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<!--part04-->
				<div class="partfour" v-show="show">
					<div class="part_tit">
						<img src="../../assets/image/seven/icon_04.png" alt="">
					</div>
					<div class="partfourinfos partbox">
						<div class="usersinfo">
							<div class="usersinfo_name">
								<div><img class="userpic" src="../../assets/image/seven/partfour_pic2.jpeg" alt=""></div>
								<div>
									<span>爱游泳的鱼</span>
									<p>即将毕业的大学生</p>
								</div>
							</div>
							<div class="userbg">
								<img src="../../assets/image/seven/partfour_pic1.png" alt="">
							</div>
							<div class="usersinfo_desc">
								<em>
									无意间看到，抱着试学的心态开始的，没想到简直超值！专家视频讲解，系统覆盖到了硬件设计的每个知识点，还有在巢粉引擎的实战，我可以独立完成IPD流程，完美补足了我缺乏项目经验的空白，并在秋招中顺利入职了我心仪的公司！
								</em>
							</div>
						</div>
						<div class="usersinfo">
							<div class="usersinfo_name">
								<div><img class="userpic" src="../../assets/image/seven/partfour_pic3.jpeg" alt=""></div>
								<div>
									<span>北城</span>
									<p>1年电子行业从业经验</p>
								</div>
							</div>
							<div class="userbg">
								<img src="../../assets/image/seven/partfour_pic1.png" alt="">
							</div>
							<div class="usersinfo_desc">
								<em>
									开始工作以来，一直觉得自己没有框架型的技术能力，知识掌握的零散，知其然不知其所以然，经常搞得自己很累，效率低下。在经过专家的视频指导后，也在群里请教了专家不少问题，我确实体会到了“从做正确的事，到正确地做事”的过程。
								</em>
							</div>
						</div>
					</div>
				</div>
				<!--part05-->
				<div class="partfive">
					<div class="part_tit">
						<img src="../../assets/image/seven/icon_05.png" alt="">
					</div>
					<div class="partfiveinfos partbox">
						<img src="../../assets/image/seven/partfive_pic.png" alt="">
					</div>
				</div>
				<!--part06-->
				<div class="partsix">
					<div class="part_tit">
						<img src="../../assets/image/seven/icon_06.png" alt="">
					</div>
					<div class="partsixinfos partbox">
						<img src="../../assets/image/seven/partsix_pic.png" alt="">
					</div>
				</div>
				<!--part07-->
				<div class="partseven">
					<div class="part_tit">
						<img src="../../assets/image/seven/icon_07.png" alt="">
					</div>
					<div class="partseveninfos partbox">
						<div class="apply_process">
							<div>
								<img class="proicon" src="../../assets/image/seven/partseven_pic1.png" alt="">
								<img class="proarrow" src="../../assets/image/seven/partseven_pic4.png" alt="">
								<img class="proicon" src="../../assets/image/seven/partseven_pic2.png" alt="">
								<img class="proarrow" src="../../assets/image/seven/partseven_pic4.png" alt="">
								<img class="proicon" src="../../assets/image/seven/partseven_pic3.png" alt="">
							</div>
							<div>
								<span>完成支付 <br> 报名成功</span>
								<span>识别二维码 <br> 添加助理</span>
								<span>获取 <br> 体验权限</span>
							</div>
						</div>
						<div class="apply_tips">
							<img src="../../assets/image/seven/partseven_pic5.png" alt="">
							<span>请务必添加助理，才能开启权限。自报名日期起，有效期1年，请在有效期内完成体验。</span>
						</div>
					</div>
				</div>
				<!--part08-->
				<div class="parteight">
					<div class="part_tit">
						<img src="../../assets/image/seven/icon_08.png" alt="">
					</div>
					<div class="parteightinfos partbox">
						<img src="../../assets/image/seven/parteight_pic.png" alt="">
					</div>
				</div>
				<!--part09-->
				<div class="partnine">
					<div class="part_tit">
						<img src="../../assets/image/seven/icon_09.png" alt="">
					</div>
					<div class="partnineinfos partbox">
						<span>电巢是电子工程师的孵化巢，凝聚了一批来自高科技电子公司的资深主管和研发专家，结合旗下专业的电子工程师社区（www.EDA365.com），以专业的技术内容，汇聚行业优质资源，系统化地打造电子工程领域生态圈。</span>
						<span>电巢总部位于创新科技之都深圳，并在北京、上海、成都、西安、南京、武汉等均设有分支机构。</span>
					</div>
				</div>
				<!--左右两边底图-->
				<div class="leftbg"><img src="../../assets/image/seven/pagebg.png" alt=""></div>
				<div class="rightbg"><img src="../../assets/image/seven/pagebg.png" alt=""></div>
			</div>
			<div class="down_btn">
				<div class="price">
					<p class="originalCost">原价 <s>￥{{activityCon.cash_origin_price}}</s></p>
					<p class="currentPrice">优惠价 ￥<span>{{activityCon.cash_price}}</span></p>
				</div>
				<div class="signUp_btn" @click="signUp">
					立即报名
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {pagebase} from '@/utils/http.js';
	import utils from '@/utils/utils';
	import WxShare from '@/utils/wxshare'

	// 百度
	var _hmt = _hmt || [];
	(function() {
		var hm = document.createElement("script");
		hm.src = "https://hm.baidu.com/hm.js?24b8cea1e8cafdb512e2f597cf3fa8df";
		var s = document.getElementsByTagName("script")[0];
		s.parentNode.insertBefore(hm, s);
	})();

	export default {
		data() {
			return {
				aid: this.$route.query.aid || '',
				platform: this.$route.query.platform || '',
				pid: this.$route.query.pid || '',
				show: false,
				activityCon: {},
			}
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				this.wxshare = new WxShare()
				if (this.platform == 1) {
					this.show = false
				} else if (this.platform == 2) {
					this.show = true
				}
				this.activity();
				this.showStat();
			},
			showStat() {
				this.$http({
					url: '/api/showStat',
					method: 'post',
					params: {
						url: window.location.href,
					}
				})
			},
			activity() {
				this.$http({
					url: '/activity/Info',
					method: 'get',
					params: {
						activity_id: this.aid,
					},
				}).then(res => {
					if (res.code >= 0) {
						let data = res.data;
						this.activityCon = data;
						document.title = data.title;
						this.wxshare.share({
							title: data.title,
							desc: data.summary,
							link: window.location.href,
							imgUrl: data.cover,
						})
					}
				})
			},
			signUp() {
				let succeedUrl = encodeURIComponent(pagebase + '/#/paySucceed?activity_id=' + this.aid);
				let project = 'seven'
				if (this.platform == 1) {
					project = encodeURIComponent('common?activity_id=200&platform=1')
				} else if (this.platform == 2) {
					project = encodeURIComponent('common?activity_id=200&platform=2')
				}
				if (utils.browserChecker.isWx()) {
					let channel = this.$route.query.channel || '';
					let open = encodeURIComponent(pagebase + '/#/payment?activity_id=' + this.aid + '&project=' + project + '&pid=' + this.pid + 'channel=' + channel + '&succeed_url=' + succeedUrl);
					let url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
					window.location.href = url;
				} else {
					this.$router.push({
						path: '/payment',
						query: {
							activity_id: this.aid,
							channel: this.$route.query.channel || '',
							project: project,
							track_id: this.$route.query.track_id || '',
							succeed_url: succeedUrl,
							pid: this.pid,
						}
					})
				}
			},
		}
	}
</script>

<style lang="css" scoped>
	.active {
		display: block;
	}

	.seven {
		background: #141070;
		padding-bottom: 8rem;
	}

	.topbg {
		width: 100%;
	}

	.topbg img {
		width: 100%;
		display: block;
	}

	.content {
		padding: 3rem 2.1rem 3.5rem 2.1rem;
		position: relative;
	}

	/*part01*/
	.partone,
	.parttwo,
	.partthree,
	.partfour,
	.partfive,
	.partsix,
	.partseven,
	.parteight {
		margin-bottom: 3rem;
	}

	.part_tit {
		margin-bottom: 2.25rem;
	}

	.part_tit img {
		width: 100%;
		height: 5.95rem;
	}

	.partbox {
		background: #FEFEFE;
		border-radius: 1rem;
	}

	.partoneinfos {
		padding-top: 2.15rem;
	}

	.partoneinfos ul li {
		padding-bottom: 3rem;
	}

	.partoneinfos ul li:nth-child(odd) div.tit_words img {
		margin-right: 1.35rem;
	}

	.partoneinfos ul li:nth-child(even) div.tit_words span {
		margin-right: 1.35rem;
		text-align: right;
	}

	.partoneinfos ul li:nth-child(even) div.tit_img {
		text-align: right;
	}

	.tit_img {
		margin-bottom: 1.1rem;
	}

	.tit_img img {
		height: 3.2rem;
		max-width: 100%;
	}

	.tit_words {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 1.4rem;
	}

	.tit_words img {
		height: 6.8rem;
	}

	.tit_words span {
		color: #3235A1;
		font-size: 1.2rem;
		line-height: 1.6rem;
	}

	/*part02*/
	.parttwoinfos {
		padding: 1rem 1.1rem 1.4rem 1.1rem;
	}

	.parttwoinfos ul {
		width: 100%;
	}

	.parttwoinfos ul li {
		width: 49%;
		position: relative;
		float: left;
		margin-top: 2.85rem;
	}

	.parttwoinfos ul li:nth-child(odd) {
		margin-right: .5rem;
	}

	.parttwoinfos ul li div.parttwo_icon {
		position: absolute;
		left: 50%;
		bottom: 75%;
		margin-left: -2.2rem;
		z-index: 2;
	}

	.parttwoinfos ul li div.parttwo_icon img {
		height: 4.4rem;
	}

	.parttwoinfos ul li div.parttwo_desc {
		background: #F1F0FB;
		border-radius: 1.2rem;
		text-align: center;
		position: relative;
		display: table;
		padding: 0 1.2rem;
	}

	.parttwoinfos ul li:nth-child(-n+4):nth-child(n+3) div.parttwo_desc {
		background: #9F74F7;
	}

	.parttwoinfos ul li:nth-child(-n+4):nth-child(n+3) div.parttwo_desc em {
		color: #FAD55E;
	}

	.parttwoinfos ul li:nth-child(-n+4):nth-child(n+3) div.parttwo_desc span {
		color: #FFFFFF;
	}

	.parttwoinfos ul li div.parttwo_desc>div {
		display: table-cell;
		text-align: center;
		vertical-align: top;
		padding-top: 2rem;
	}

	.parttwoinfos ul li:nth-child(-n+4) div.parttwo_desc {
		height: 8.95rem;
	}

	.parttwoinfos ul li:nth-child(n+5) div.parttwo_desc {
		height: 10.9rem;
	}

	.parttwoinfos ul li div.parttwo_desc em {
		color: #F764EF;
		font-size: 2rem;
		line-height: 2.8rem;
		font-style: normal;
	}

	.parttwoinfos ul li div.parttwo_desc span {
		color: #3235A1;
		font-size: 1.4rem;
		line-height: 2.8rem;
	}

	/*part03*/
	.partthreeinfos {
		padding: 3.3rem 1.6rem 2.6rem 1.6rem;
	}

	.partthree_box {
		display: flex;
		padding-bottom: 2.2rem;
		background-image: url("../../assets/image/seven/partthree_pic2.png");
		background-repeat: no-repeat;
		background-position: 3% 0;
		background-size: .15rem 100%;
	}

	.partthree_box:last-child {
		padding-bottom: 0;
	}

	.partthree_box div:first-child {
		margin-right: 1.35rem;
	}

	.partthree_box div:last-child {
		width: 100%;
	}

	.partthree_box img {
		width: 1.75rem;
		background: #fff;
	}

	.partthree_box span {
		color: #6753D5;
		font-size: 1.6rem;
		line-height: 2.5rem;
	}

	.partthree_box p {
		color: #6753D5;
		font-size: 2rem;
		line-height: 2.5rem;
		font-weight: 600;
	}

	.partthree_box ul {
		margin-top: .85rem;
	}

	.partthree_box ul li {
		color: #8D7FAA;
		font-size: 1.4rem;
		line-height: 2rem;
	}

	.partthree_box ul li span {
		color: #8D7FAA;
		font-size: 1.4rem;
		line-height: 2rem;
	}

	.partthree_box ul li i {
		background: #A075FB;
		width: .5rem;
		height: .5rem;
		border-radius: 50%;
		margin-right: .75rem;
		display: inline-block;
		margin-bottom: .3rem;
	}

	.partthree_box h4 {
		color: #fff;
		font-size: 1.2rem;
		background: #9F74F7;
		display: block;
		padding: .3rem .6rem;
		margin-top: .8rem;
		line-height: 2rem;
	}

	/*part04*/
	.partfourinfos {
		padding: 1.8rem .9rem;
	}

	.usersinfo {
		border-radius: 1rem;
		background: #F1F0FB;
	}

	.usersinfo:last-child {
		margin-top: 1.2rem;
	}

	.usersinfo_name {
		display: flex;
		padding: 1.4rem 1.2rem 0 1.2rem;
	}

	.usersinfo_name:first-child div {
		margin-right: 1.45rem;
	}

	.usersinfo_name img.userpic {
		width: 3.9rem;
		height: 3.9rem;
		border-radius: 50%;
	}

	.userbg {
		padding: 0 1.3rem 0 .6rem;
	}

	.userbg img {
		width: 100%;
		display: block;
	}

	.usersinfo_name span {
		color: #6753D5;
		font-size: 1.5rem;
		line-height: 2.1rem;
	}

	.usersinfo_name p {
		color: #E07E40;
		font-size: 1.4rem;
		line-height: 2rem;
	}

	.usersinfo_desc {
		padding: .3rem 1.2rem 1.7rem 1.2rem;
	}

	.usersinfo_desc em {
		font-style: normal;
		color: #3235A1;
		font-size: 1.2rem;
		line-height: 1.6rem;
	}

	/*part05*/
	.partfiveinfos {
		padding: 1.9rem .5rem 2.4rem .5rem;
	}

	.partfiveinfos img {
		width: 100%;
		display: block;
	}

	/*part06*/
	.partsixinfos {
		padding: 1.1rem .35rem 1.6rem .35rem;
	}

	.partsixinfos img {
		width: 100%;
		display: block;
	}

	/*part07*/
	.apply_process {
		padding: 1.4rem 1.7rem;
	}

	.apply_process>div {
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.apply_process>div:last-child {
		padding: 0 1rem;
	}

	.apply_process img.proicon {
		width: 6.8rem;
	}

	.apply_process img.proarrow {
		width: 2rem;
		height: 2rem;
	}

	.apply_process span {
		color: #6753D5;
		font-size: 1.3rem;
		font-weight: 600;
		line-height: 2rem;
	}

	.apply_tips {
		padding: 2rem 1rem;
	}

	.apply_tips img {
		width: 100%;
	}

	.apply_tips span {
		color: #3235A1;
		font-size: 1.2rem;
		line-height: 1.6rem;
		padding: 0 .4rem;
		display: block;
	}

	/*part08*/
	.parteightinfos {
		padding: .9rem .7rem 1.4rem .7rem;
	}

	.parteightinfos img {
		width: 100%;
		display: block;
	}

	/*part09*/
	.partnineinfos {
		padding: 1.7rem 1.2rem .8rem 1.2rem;
	}

	.partnineinfos span {
		color: #3235A1;
		font-size: 1.4rem;
		line-height: 2rem;
		display: block;
	}

	.partnineinfos span:last-child {
		margin-top: 1rem;
	}

	/*左右底图*/
	.leftbg,
	.rightbg {
		position: absolute;
		height: 98%;
		margin: 0 .5rem;
		top: 2%;
	}

	.leftbg img,
	.rightbg img {
		height: 99%;
	}

	.leftbg {
		left: 0
	}

	.rightbg {
		right: 0;
	}

	.down_btn {
		box-sizing: border-box;
		width: 100%;
		background-color: rgba(0, 0, 0, 0.6);
		z-index: 3;
		position: fixed;
		align-items: center;
		left: 0;
		bottom: 0;
		justify-content: center;
		display: flex;
		justify-content: space-between;
		padding: 1.5rem 2.5rem;
		color: #FFF;
	}

	.price {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.originalCost {
		color: #DDD;
		font-size: 1.2rem;
		font-weight: 600;
	}

	.currentPrice {
		font-size: 1.4rem;
		font-weight: 600;
	}

	.currentPrice span {
		font-size: 2rem;
		font-weight: 600;
		color: #FFE864;
	}

	.signUp_btn {
		box-sizing: border-box;
		text-align: center;
		width: 12rem;
		height: 3.4rem;
		line-height: 3.4rem;
		font-size: 1.5rem;
		font-weight: 600;
		color: #FFFFFF;
		background: linear-gradient(#B08CFF, #6753E7);
		border-radius: 2.2rem;
	}

	@media (min-width: 751px) {
		.down_btn {
			width: 750px;
			left: 50%;
			margin-left: -375px;
		}
	}
</style>
